<isav-autocomplete
    (search)="this.searchPeople($event)"
    (choose)="onSelected($event)"
    [options]="people$ | async"
    label="Select person"
    placeholder="Search for people"
>
    <span *isavAutocompleteOption="let person">{{ person.fullName }}</span>
</isav-autocomplete>
